export default __webpack_public_path__ + "static/media/edit-icon-black.31200f56.svg";